export default __webpack_public_path__ + "static/media/grid_word.71dd4ae4.svg";